<script>
    import { onMount } from 'svelte' 

    let show = false
    let annotation = null

    onMount(() => {
        document.onclick = function(evt) {
            const meta = evt.target.dataset.annotation
            if(evt.ctrlKey && meta) {
                const next = JSON.parse(meta)
                const other = annotation && annotation.target.id !== next.target.id
                annotation = next
                show = !show || other
            }
        }
    })

    function typeGiven(type) {
        switch(type) {
            case "company"  : return "Empresa"
            case "place"    : return "Lugar"
            case "field"    : return "Campo"
            case "activity" : return "Atividade"
            default: return type
        }
    }

</script>

<div class="annotations" class:show>
    <div class="logo">
        <img src="/logo-h-black.png" alt="Dogma"/>
    </div>
    <div class="container">
        <h2 class="ui title">Anotações</h2>
        {#if annotation}
            <form class="ui form">
                <div class="field">
                    <label for="item">Ítem</label>
                    {annotation.name}
                </div>
                <div class="field">
                    <label for="type">Tipo</label>
                    {typeGiven(annotation.type)}
                </div>
                <div class="field">
                    <label for="title">Título</label>
                    <input id="title" type="text">
                </div>
                <div class="field">
                    <label for="desc">Descrição</label>
                    <textarea id="desc" rows="5"></textarea>
                </div>
                <button class="ui button" type="submit">Adicionar</button>
            </form>        
        {/if}
    </div>
</div>

<style>

    .logo {
        width: 200px;
        margin: 60px auto 20px auto;
    }

    .logo img {
        width: 200px;
    }

    .annotations {
        position: fixed;
        top: 0;
        left: -300px;
        width: 300px;
        height: 100vh;
        background-color: white;
        transition: left .7s cubic-bezier(0, 1, 0.5, 1);
    }

    .annotations.show {
        left: 0;
    }

    .container {
        padding: 1em;
        width: 100%;
    }

    .container h2 {
        margin: 1em auto;
    }
</style>